import React, { useEffect, useMemo, useState } from 'react'
import { MemoryRouter, Route, useHistory } from 'react-router-dom'
import { AuthContext } from '../../App'
import Blog from './Blog'
import {
  createLocalId,
  listLocalMaterials,
  upsertLocalMaterial,
  upsertLocalTag,
} from '../../api/blog/blogLocalStore'
import { BLOG_STATUS, BLOG_SYSTEM_AUTHOR_ID } from '../../api/blog/blogConstants'
import { createEmptyBlock } from './editor/blockFactory'

function DemoChrome({ children }) {
  const history = useHistory()
  return (
    <div style={{ padding: 16, background: '#f5f5f5', minHeight: '100vh' }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <button type="button" onClick={() => history.push('/blog/materials')}>
          Матеріали
        </button>
        <button type="button" onClick={() => history.push('/blog/tags')}>
          Теги
        </button>
        <button type="button" onClick={() => history.push('/blog/materials/new')}>
          Новий матеріал
        </button>
      </div>
      <p style={{ margin: '0 0 12px', fontSize: 13, color: '#666' }}>
        Локальний UI-перегляд «Блог» (без Firebase auth)
      </p>
      {children}
    </div>
  )
}

async function seedDemoDataOnce() {
  if (typeof window === 'undefined') return
  upsertLocalTag({
    id: 'demo-tag-care',
    name: 'Догляд',
    slug: 'doglyad',
    publishedCount: 0,
  })
  const existing = await listLocalMaterials()
  if (existing.length) return
  const id = createLocalId()
  const paragraph = createEmptyBlock('paragraph')
  paragraph.content = {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [
          { type: 'text', marks: [{ type: 'bold' }], text: 'Essentielle Exfoliation Peeling' },
          { type: 'text', text: ' — тестовий матеріал для перегляду інтерфейсу.' },
        ],
      },
    ],
  }
  await upsertLocalMaterial({
    id,
    status: BLOG_STATUS.draft,
    title: 'Essentielle Exfoliation Peeling',
    slug: 'essentielle-exfoliation-peeling',
    authorId: BLOG_SYSTEM_AUTHOR_ID,
    tagIds: ['demo-tag-care'],
    draft: {
      schemaVersion: 1,
      title: 'Essentielle Exfoliation Peeling',
      slug: 'essentielle-exfoliation-peeling',
      excerpt: 'Короткий опис для таблиці',
      authorId: BLOG_SYSTEM_AUTHOR_ID,
      tagIds: ['demo-tag-care'],
      cover: null,
      seo: { title: '', description: '', ogImage: null },
      blocks: [paragraph],
      toc: [],
      readingTimeMinutes: 1,
      contentSavedAt: Date.now(),
    },
    updatedAtSort: Date.now(),
  })
}

function BlogUiDemo() {
  const [ready, setReady] = useState(false)
  const [pageTitle, setPageTitle] = useState('Блог')
  const user = useMemo(
    () => ({
      uid: 'blog-ui-demo',
      providerData: [{ providerId: 'password' }],
    }),
    []
  )

  useEffect(() => {
    let cancelled = false
    seedDemoDataOnce().then(() => { if (!cancelled) setReady(true) })
    return () => { cancelled = true }
  }, [])
  if (!ready) return <p>Завантажуємо…</p>

  return (
    <AuthContext.Provider value={{ user, cities: [], pageTitle, setPageTitle }}>
      <MemoryRouter initialEntries={['/blog/materials']}>
        <DemoChrome>
          <Route path="/blog" component={Blog} />
        </DemoChrome>
      </MemoryRouter>
    </AuthContext.Provider>
  )
}

export default BlogUiDemo
